import { render, staticRenderFns } from "./LostPhone.vue?vue&type=template&id=36953cbe"
import script from "./LostPhone.vue?vue&type=script&lang=js"
export * from "./LostPhone.vue?vue&type=script&lang=js"
import style0 from "./LostPhone.vue?vue&type=style&index=0&id=36953cbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports